import React from 'react';
export var AuthPropsContext = /*#__PURE__*/React.createContext({
  signinComplete: function signinComplete(_) {}
});
export var useSigninComplete = function useSigninComplete() {
  return React.useContext(AuthPropsContext).signinComplete;
};

/**
 * provides additional props to auth components
 * @param signinComplete - handles all sign in scenarios
 * @returns `JSX.Element`
 */
export var AuthPropsProvider = function AuthPropsProvider(_ref) {
  var children = _ref.children,
    signinComplete = _ref.signinComplete;
  return /*#__PURE__*/React.createElement(AuthPropsContext.Provider, {
    value: {
      signinComplete: signinComplete
    }
  }, children);
};